<template>
    <div class="pa-1">
        <v-row class="card" align="center" :style="`min-height: ${minHeight}`">
            <v-col v-if="img || icon || color" :cols="img || icon ? 3 : 2" align="center">
                <v-avatar v-if="img || icon" size="40" :color="color" :style="`background: ${color}`">
                    <v-img v-if="img" max-width="30" contain :src="imgCard"/>
                    <v-icon v-else color="#8bc53f" v-text="icon"/>
                </v-avatar>
                <v-avatar v-else size="8" :color="color"/>
            </v-col>
            <v-col :cols="colsContent" :class="[{'text-center': colsContent === 12}]">
                <div class="title-card text-truncate">
                    {{ title }}
                </div>
                <div class="number-card text-truncate">
                    {{ isMoney ? '$' : '' }}{{ number | number }}
                </div>
                <div v-if="showPercent" class="from-card text-truncate">
                    <span :class="['percent-card', {'negative': isNegative}]">{{ percentNumber }}%</span> {{ fromLast }}
                </div>
                <div v-else style="height: 20px"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "GraphicsCard",
    props: {
        img: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
        title: {
            type: String,
            default: '',
        },
        number: {
            type: [String, Number],
            default: '',
        },
        percent: {
            type: [String, Number],
            default: null,
        },
        fromLast: {
            type: String,
            default: 'desde última semana',
        },
        minHeight: {
            type: [String, Number],
            default: undefined,
        },
        isMoney: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        imgCard(vm = this) {
            return require(`@/assets/icons/${vm.img}.png`)
        },
        colsContent(vm = this) {
            if (!vm.color && (!vm.img || !vm.icon)) return 12
            return vm.img || vm.icon ? 9 : 10
        },
        isNegative(vm = this) {
            return vm.percent < 0
        },
        percentNumber(vm = this) {
            let percent = vm.percent.toFixed(0)
            return !vm.isNegative ? `+${percent}` : percent
        },
        showPercent(vm = this) {
            return !!vm.percent || vm.percent === 0
        }
    }
}
</script>

<style scoped>

.card {
    background: #FFFFFF;
    border-radius: 20px;
}

.title-card {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #A3AED0;
}

.number-card {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #2B3674;
}

.percent-card {
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #8BC53F;
}

.negative {
    color: #FF9800;
}

.from-card {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #A3AED0;
}

</style>